import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header/header.component';
import { FooterComponent } from './footer/footer.component';
import { FormActionsComponent } from './form-actions/form-actions.component';
import { DialogContentComponent } from './dialog-content/dialog-content.component';
import { RouterModule } from '@angular/router';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';

@NgModule({
  declarations: [
    HeaderComponent,
    FooterComponent,
    FormActionsComponent,
    DialogContentComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    MatButtonModule,
    MatDialogModule
  ],
  exports: [
    HeaderComponent,
    FooterComponent,
    FormActionsComponent,
    DialogContentComponent
  ]
})
export class SharedModule { }
